export const getValuesWithNewLines = (values: string[], uppercase = true) => {
    const replaceStartEmptyLinesRegex = /^\s*[\r\n]/gm;
    const eachValueFromNewLine = values.join("\n").replace(replaceStartEmptyLinesRegex, "")?.trim();
    if (uppercase) {
        return eachValueFromNewLine.toUpperCase();
    }
    return eachValueFromNewLine;
};
